import hubAPI from "../../hubAPI";

const ROOT_PATH = "api/v1/OneMobilitySingleRegistry";

/**
 * @param {number} CompanyId
 * @param {Array} integratorSolutionCodes
 * @returns {Promise}
 */
export const downloadVehicleTemplateFile = async (
  companyId,
  integratorSolutionCodes,
  emptyFile,
  locale = "en-US",
) =>
  hubAPI.post(
    `${ROOT_PATH}/companies/${companyId}/vehicles/file-template/${emptyFile}?culture=${locale}`,
    {
      IntegratorSolutionCodes: integratorSolutionCodes,
    },
    {
      responseType: "blob",
    },
  );

  /**
 * @param {number} CompanyId
 * @param {FormData} formData
 * @returns {Promise}
 */
export const uploadFileVehicles = async (
  companyId,
  formData,
  axiosConfig = {},
  locale = "en-US",
) =>
  hubAPI.post(
    `${ROOT_PATH}/companies/${companyId}/vehicles/upload?culture=${locale}`,
    formData,
    axiosConfig,
  );

  
  /**
 * @param {number} companyId
 * @param {Object} filters
 * @param {string} [filters.search]
 * @param {string} [filters.status]
 * @param {string} [filters.platform]
 * @param {string} [filters.operation]
 * @param {number} [filters.pageIndex]
 * @param {number} [filters.pageSize]
 * @param {string} [filters.sortProperty]
 * @param {string} [filters.sortDirection]
 * @returns {Promise}
 */
export const getSynchronizedHistory = async (companyId, filters) => {
  return hubAPI.get(`${ROOT_PATH}/companies/${companyId}/vehicles/synchronization-history`, {
    params: filters,
  });
};

/**
 * @param {number} companyId
 * @param {Object} request
 * @param {number} [request.pageIndex]
 * @param {number} [request.pageSize]
 * @param {string} [request.sortProperty]
 * @param {string} [request.sortDirection]
 * @returns {Promise}
 */
export const getVehicles = async (companyId, locale, request) => {
  return hubAPI.post(
      `${ROOT_PATH}/companies/${companyId}/vehicles?culture=${locale}`,
      request,
    );
};